const SR = function () {
  this.version = '0.3'
  this.debug = false
  this.recognition = null
  this.recognitionResultCb = null
  this.startCB = null
  this.recognitionErrorCb = null
  this.recognitionEndCb = null
  this.isEnabled = false
  this.isRecognising = false
  this.hasResult = false
  this.interimResult = ''
  this.confidence = 0

  this.init = async () => {
    if (!window.SpeechRecognition && !window.webkitSpeechRecognition) {
      this.isEnabled = false
      this.setup = true
      throw new Error('SpeechRecognition API not available')
    }
    if (/android/i.test(navigator.userAgent)) {
      throw new Error('Android not supported for speech recognition.')
    }
    // Arc en Brave claimen webkitSpeechRecognition te supporten maar missen de Google Speech-service
    const ua = navigator.userAgent
    const isChrome = /Chrome\//.test(ua) && navigator.vendor === 'Google Inc.' && !/Edg\/|OPR\/|Vivaldi\/|SamsungBrowser\//.test(ua) && !navigator.brave && getComputedStyle(document.documentElement).getPropertyValue('--arc-palette-background').trim() === ''
    const isSafari = /Safari\//.test(ua) && navigator.vendor === 'Apple Computer, Inc.' && !/Chrome\//.test(ua)
    if (!isChrome && !isSafari) {
      this.isEnabled = false
      throw new Error('Speech recognition not supported in this browser.')
    }
    try {
      this.recognition = window.SpeechRecognition
        ? new window.SpeechRecognition()
        : new window.webkitSpeechRecognition()

      this.recognition.continuous = false
      this.recognition.interimResults = false
      this.recognition.lang = 'nl-NL'
      this.recognition.maxAlternatives = 1

      const me = this

      this.recognition.onstart = () => {
        me.hasResult = false
        me.interimResult = ''
        if (me.startCB) me.startCB()
      }

      this.recognition.onresult = (event) => {
        const last = event.results.length - 1
        const result = event.results[last]
        const confidence = result[0].confidence
        const transcript = result[0].transcript
        const isFinal = result.isFinal

        if (isFinal) {
          me.hasResult = true
          me.interimResult = ''
          if (me.recognitionResultCb) me.recognitionResultCb(transcript, confidence)
        } else {
          me.interimResult += transcript
          me.confidence = confidence
        }
      }

      this.recognition.onerror = (event) => {
        switch (event.error) {
          case 'network':
            console.error('Network error during speech recognition.')
            if (!this.setup) this.isEnabled = false
            break
          case 'audio-capture':
            console.error('Error capturing audio. Check microphone permissions.')
            this.isEnabled = false
            break
          case 'language-not-supported':
            this.isEnabled = false
            break
          case 'no-speech':
            // ignoreer: gebruiker heeft niet gesproken
            break
          case 'aborted':
            // ignoreer: normaal einde
            break
          case 'not-allowed':
            console.error('Microphone not allowed. Check browser permissions.')
            this.isEnabled = false
            break
          case 'service-not-allowed':
            this.isEnabled = false
            break
          default:
            console.error('Speech recognition error:', event.error)
            this.isEnabled = false
        }

        if (this.isEnabled) return
        if (this.setup) throw new Error('Speechrecognition setup error')
        if (me.recognitionErrorCb) me.recognitionErrorCb(event)
      }

      this.recognition.onend = () => {
        me.isRecognising = false
        if (!me.hasResult) {
          if (me.interimResult === '') me.confidence = 100
          if (me.recognitionResultCb) me.recognitionResultCb(me.interimResult, me.confidence)
        }
        if (me.recognitionEndCb) me.recognitionEndCb()
        me.recognitionResultCb = null
        me.startCB = null
        me.recognitionErrorCb = null
        me.recognitionEndCb = null
      }

      this.recognition.onspeechend = () => {
        this.recognition.stop()
      }

      this.recognition.onnomatch = () => {
        if (me.recognitionResultCb) me.recognitionResultCb('', 0)
      }

      this.setup = false
      this.isEnabled = true
      return true
    } catch (error) {
      console.error('Error setting up speech recognition:', error)
      this.isEnabled = false
      throw error
    }
  }

  this.stopRecognition = () => {
    if (!this.isEnabled) return
    this.isRecognising = false
    this.recognition.stop()
  }

  this.startRecognition = (errorCB, startCB, resultCB, endCB) => {
    this.recognitionResultCb = resultCB
    this.startCB = startCB
    this.recognitionErrorCb = errorCB
    this.recognitionEndCb = endCB
    if (!startCB || !errorCB) {
      console.error('startCB and errorCB are required')
      return false
    }
    if (!this.isEnabled || this.isRecognising) return false
    this.isRecognising = true
    try {
      this.recognition.start()
    } catch (e) {
      console.log(e)
      return false
    }
    return true
  }

  this.log = (msg) => {
    if (this.debug) console.log(msg)
  }
}

const speechrecognition = new SR()

export { speechrecognition }
